module.exports = __webpack_public_path__ + "static/media/19ESCAP7.e8b95370.jpg";